import React, {FC, useEffect} from 'react'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../helpers'
import {TicketDrawerItem} from '../../../../app/components/TicketDrawerItem'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import * as appRedux from '../../../../app/store/app'

const DrawerMessenger: FC = () => {
  const {data: tickets, isLoading}: any = useSelector<RootState>(({app}) => app.tickets)
  const dispatch = useDispatch()

  const account: any = useSelector<RootState>(({account}) => account.appAccount)

  useEffect(() => {
    dispatch(
      appRedux.actions.getTicketsRequest({
        pageNumber: 1,
        pageSize: 20,
        orderBy: 'desc',
      })
    )
  }, [dispatch])

  return (
    <div
      id='kt_ticket'
      className='bg-white'
      data-kt-drawer='true'
      data-kt-drawer-name='ticket'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'200px', 'lg': '900px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_ticket_toggle'
      data-kt-drawer-close='#kt_ticket_close'
    >
      <div className='card shadow-none rounded-0 w-100'>
        <div className='card-header' id='kt_ticket_header'>
          <h3 className='card-title fw-bolder text-dark'>Ticketlar</h3>
          <div className='card-toolbar'>
            <button
              type='button'
              className='btn btn-sm btn-icon btn-active-light-primary me-n5'
              id='kt_ticket_close'
            >
              <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
            </button>
          </div>
        </div>
        <div className='card-body position-relative' id='kt_ticket_body'>
          <div
            id='kt_activities_scroll'
            className='position-relative scroll-y me-n5 pe-5'
            data-kt-scroll='true'
            data-kt-scroll-height='auto'
            data-kt-scroll-wrappers='#kt_ticket_body'
            data-kt-scroll-dependencies='#kt_ticket_header, #kt_ticket_footer'
            data-kt-scroll-offset='0'
          >
            <div className='timeline'>
              <div className='timeline-item'>
                <div className='timeline-content mb-10 mt-n1'>
                  <div className='pe-3 mb-5'>
                    <div className='d-flex align-items-center mt-1 fs-6 me-2' />
                  </div>
                  <div className='overflow-auto pb-5'>
                    {tickets?.length > 0 ? (
                      tickets.map((ticket: any, index: number) => (
                        <TicketDrawerItem
                          account={account}
                          id={ticket?.id}
                          subject={ticket?.subject}
                          status={ticket.status}
                          ticketReplies={ticket.ticketReplies}
                          key={index}
                        />
                      ))
                    ) : isLoading ? (
                      <div className='text-center'>Yükleniyor...</div>
                    ) : (
                      <div className='text-center'>Ticketınız bulunmuyor...</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='card-footer py-5 text-center' id='kt_ticket_footer'>
          <div className='fw-normal text-muted ps-3 text-italic text-center mb-5'>
            Fleksup yetkilisi tarafından cevaplanan destek taleplerinize geri dönüş yapılmadığı
            taktirde 24 saat sonra destek talebiniz kapatılacaktır.
          </div>
          <Link to='/tickets' className='btn btn-bg-white text-primary'>
            Tüm Ticketları Göster
            <KTSVG
              path='/media/icons/duotune/arrows/arr064.svg'
              className='svg-icon-3 svg-icon-primary'
            />
          </Link>
        </div>
      </div>
    </div>
  )
}

export default DrawerMessenger
